import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import closeButton from '../img/close-30-grey';

// Actions.
import { mobileMenuClose } from '../../contactUs/actions/action-mobile-filter';

// Components or containers
import SearchFilterForm from './SearchFilterForm';

// Helpers.
import i18n from '../../lib/reacti18n';

// Locales.
const filterLabel = i18n.message('smarthelp/searchResult.searchResult.mobile.header.label');

class MobileFilterModal extends Component {
  static renderMobileFilterBody() {
    return (
      <div className="mobile-filter-body">
        <SearchFilterForm />
      </div>
    );
  }

  renderMobileFilterHeader() {
    return (
      <div className="mobile-filter-header">
        <span className="mobile-filter-header-label">{filterLabel}</span>
        <button
          type="button"
          className="mobile-filter-close-btn close"
          aria-label="Close"
          onClick={this.props.mobileMenuClose}
        >
          {closeButton}
        </button>
      </div>
    );
  }

  renderMobileModal() {
    return (
      <div className="mobile-filter-container">
        {this.renderMobileFilterHeader()}
        {MobileFilterModal.renderMobileFilterBody()}
      </div>
    );
  }

  render() {
    if (!this.props.display) {
      return null;
    }
    return (
      <div className="mobile-modal">
        {this.renderMobileModal()}
      </div>
    );
  }
}

MobileFilterModal.propTypes = {
  display: PropTypes.bool,
  mobileMenuClose: PropTypes.func.isRequired,
};

MobileFilterModal.defaultProps = {
  display: false,
};

// Dispatch the Action as Props.
function mapDispatchToProps(dispatch) {
  return bindActionCreators({ mobileMenuClose }, dispatch);
}

// Get the Store data and Pass it as Props.
function mapStateToProps(state) {
  return {
    display: state.mobileFilter.display,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(MobileFilterModal);



// WEBPACK FOOTER //
// ./home/containers/MobileFilterModal.js